import React, { Component } from "react";
import { Form, Button } from "react-bootstrap";
import errorConfig from "../../config/errorConfig.json";
import { getFromStorage } from "../../utils/storage";
import { withRouter } from "react-router-dom";
import key from "../../config/key.json";
import Files from "react-butterfiles";
import xlsx from "../../image/xlsx.png";
import upload from "../../image/upload.png";
import View from "../List/View";
import { toast } from "react-toastify";
import axios from "axios";
import apiURL from "../../config/api.json";
import QRCode from "qrcode.react";

class EditCaseInfo extends Component {
  state = {
    patient_phone: "",
    study_type: "",
    comment: "",
    referring_physician: "",
    files: [],
    errors: [],
    priority: 0,
    isClicked: false,
  };
  whenChangeHandler = (e) => {
    const { value, name } = e.target;
    this.setState({ [name]: value });
  };

  notifyError = (str) => {
    toast.error(str);
  };

  notifySuccess = (str) => {
    toast.success(str);
  };

  whenSubmitHandler = (e) => {
    e.preventDefault();
    if (getFromStorage(key.loginInfoKey)) {
      if (getFromStorage(key.loginInfoKey).task === "authAdmin") {
        window.open("/#/View");
      } else {
        this.setState({ isClicked: true });
      }
    }
  };

  //Set Priority POST request
  setInfo = () => {
    toast.dismiss();
    console.log("in set Info");
    axios
      .post(
        apiURL.postMethodURL,
        {
          task: "setCaseInfo",
          report_id: getFromStorage("edit_case")[1],
          patient_phone: this.state.patient_phone,
          study_type: this.state.study_type,
          comment: this.state.comment,
          referring_physician: this.state.referring_physician,
          priority: this.state.priority,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        this.notifySuccess("Data Updated Successfully");
      })
      .catch((err) => {
        this.notifyError(err.toString());
        console.log(err.toString());
      });
  };

  //onClick Set Info
  setInfoHandler = () => {
    this.setInfo();
  };

  //First function run when page load
  componentDidMount() {
    toast.dismiss();
    if (!getFromStorage(key.loginInfoKey)) {
      this.notifyError(errorConfig.notLoggedInError);
      this.props.history.push("/");
    } else {
      this.setState({
        priority: getFromStorage("edit_case")
          ? getFromStorage("edit_case")[0]
          : 0,
        referring_physician: getFromStorage("edit_case")
          ? getFromStorage("edit_case")[2]
          : "",
        study_type: getFromStorage("edit_case")
          ? getFromStorage("edit_case")[3]
          : "",
      });
    }
  }
  render() {
    if (getFromStorage(key.loginInfoKey)) {
      return (
        <div
          style={{
            marginLeft: "80px",
            color: "teal",
            marginRight: "20px",
            marginTop: "105px",
          }}
          align="center"
        >
          {/*Start of Files For Upload*/}
          <Files
            maxSize="1000mb"
            multipleMaxSize="1000mb"
            multiple={true}
            onSuccess={(files) => this.setState({ files })}
            onError={(errors) => this.setState({ errors })}
          >
            {({ browseFiles, getDropZoneProps }) => {
              return (
                <div
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  {/*Start of Div 2*/}
                  <div
                    {...getDropZoneProps({
                      style: {
                        width: "500px",
                        padding: "10px",
                        mainHeight: 140,
                        border: "2px lightgray dashed",
                      },
                    })}
                  >
                    {/*Start of Ordered List*/}
                    <ol>
                      {/*Start of List 2 with Condition if errors found and file found*/}
                      {this.state.errors.length === 0 &&
                        this.state.files.length === 0 && (
                          <React.Fragment>
                            <li style={{ listStyle: "none" }}>
                              <img
                                src={upload}
                                alt="upload"
                                style={{
                                  width: "70px",
                                  cursor: "pointer",
                                }}
                                onClick={browseFiles}
                              />
                            </li>
                            <li style={{ listStyle: "none", fontSize: "14px" }}>
                              <br />
                              <strong>Select File</strong> or Drag and Drop Here
                              (.pdf Only)
                            </li>
                          </React.Fragment>
                        )}
                      {/*End of List 2 with Condition if errors found and file found*/}
                      <li style={{ listStyle: "none" }}>
                        {/*Start Div 3*/}
                        {this.state.files.map((file) => (
                          <div className="ma2 pa2 dib" key={file.name}>
                            {/*Start of image of file*/}
                            <img
                              src={xlsx}
                              alt="xlsx"
                              style={{
                                width: "50px",
                                display: "inline",
                              }}
                            />
                            <br />
                            {/*End of image of xlsx*/}

                            {/*Start of Filename*/}
                            <strong
                              style={{
                                fontSize: "14px",
                              }}
                            >
                              {file.name}
                            </strong>
                            <br />
                            {/*End of Filename*/}

                            {/*Start of Cancel Button*/}
                            <Button
                              variant="danger"
                              onClick={() => {
                                this.setState({
                                  errors: [],
                                  files: this.state.files.filter(
                                    (filee) => filee.name !== file.name
                                  ),
                                });
                              }}
                              style={{
                                fontSize: "12px",
                                textTransform: "none",
                              }}
                              align="right"
                            >
                              Cancel X
                            </Button>
                            {/*End of Cancel Button*/}
                          </div>
                        ))}
                        {/*End of Div 3*/}
                      </li>
                      {/*Start of List 4 with condition if errors found and files not found*/}
                      {this.state.errors.length === 0 &&
                        this.state.files.length !== 0 && (
                          <li style={{ listStyle: "none" }}>
                            <Button
                              variant="outline-danger"
                              onClick={() => {
                                this.setState({ errors: [], files: [] });
                              }}
                              style={{ textTransform: "none" }}
                              size="sm"
                            >
                              Cancel All X
                            </Button>
                          </li>
                        )}
                      {/*End of List 4 with condition if errors found and files not found*/}

                      {/*Start of List 6 if errors not found*/}
                      {this.state.errors.length !== 0 && (
                        <li style={{ listStyle: "none" }}>
                          Error in files
                          <br />
                          <Button
                            variant="outline-danger"
                            style={{ textTransform: "none" }}
                            onClick={() => {
                              this.setState({ errors: [], files: [] });
                            }}
                            size="sm"
                          >
                            Cancel All X
                          </Button>
                          <br />
                          <br />
                          <br />
                        </li>
                      )}
                      {/*Start of List 6 if errors not found*/}
                    </ol>
                    {/*End of Ordered List*/}
                  </div>
                  {/*End of Div 2*/}
                </div>
              );
            }}
          </Files>
          {/*End of Files*/}
          <Form
            style={{
              textAlign: "center",
              overflowX: "auto",
              marginTop: "10px",
            }}
          >
            <div className="ma1 pa0 dib">
              <Form.Group>
                <Form.Label style={{ fontWeight: "bold" }}>
                  Referring Physician
                </Form.Label>
                <Form.Control
                  type="text"
                  value={this.state.referring_physician}
                  name="referring_physician"
                  onChange={this.whenChangeHandler}
                  style={{
                    width: "300px",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                  align="center"
                />
              </Form.Group>
            </div>
            <div className="ma1 pa0 dib">
              <Form.Group>
                <Form.Label style={{ fontWeight: "bold" }}>
                  Patient Phone
                </Form.Label>
                <Form.Control
                  type="text"
                  value={this.state.patient_phone}
                  name="patient_phone"
                  onChange={this.whenChangeHandler}
                  style={{
                    width: "300px",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                  align="center"
                />
              </Form.Group>
            </div>
            <br />
            <div className="ma1 pa0 dib">
              <Form.Group>
                <Form.Label style={{ fontWeight: "bold" }}>
                  Study Type
                </Form.Label>
                <Form.Control
                  type="text"
                  value={this.state.study_type}
                  name="study_type"
                  onChange={this.whenChangeHandler}
                  style={{
                    width: "300px",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                  align="center"
                />
              </Form.Group>
            </div>
            <div className="ma1 pa0 dib">
              <Form.Group>
                <Form.Label style={{ fontWeight: "bold" }}>Priority</Form.Label>
                <Form.Control
                  as="select"
                  value={this.state.priority}
                  name="priority"
                  onChange={this.whenChangeHandler}
                  style={{
                    width: "300px",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                  align="center"
                >
                  <option value={0}>Regular</option>
                  <option value={1}>High</option>
                </Form.Control>
              </Form.Group>
            </div>
            <Form.Group>
              <Form.Label style={{ fontWeight: "bold" }}>Comment</Form.Label>
              <Form.Control
                as="textarea"
                value={this.state.comment}
                name="comment"
                onChange={this.whenChangeHandler}
                style={{
                  width: "300px",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
                align="center"
              />
            </Form.Group>

            <Form.Group>
              <Button
                variant="success"
                color="primary"
                style={{
                  textTransform: "none",
                  width: "150px",
                  fontSize: "14px",
                }}
                onClick={this.setInfoHandler}
                size="sm"
              >
                Set Information
              </Button>
            </Form.Group>
            <QRCode
              value={`Report Id: ${
                getFromStorage("edit_case") ? getFromStorage("edit_case")[1] : ""
              } \nPatient Name: ${getFromStorage("edit_case") ? getFromStorage("edit_case")[4] : ""}\nExamined Organ: ${this.state.study_type}`}
              style={{ width: "200px", height: "200px" }}
            />
            <Form.Group>
              <Button
                variant="danger"
                onClick={this.whenSubmitHandler}
                size="sm"
              >
                View Image
              </Button>
            </Form.Group>
          </Form>
          {getFromStorage(key.loginInfoKey) &&
            getFromStorage(key.loginInfoKey).task === "authDiagAdminPanel" &&
            this.state.isClicked && (
              <div style={{ textAlign: "left", color: "black" }}>
                <View />
              </div>
            )}
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}

export default withRouter(EditCaseInfo);
